import React from "react";
import { useTranslations } from "@jugl-web/utils";
import { useInstagramAccount } from "@web-src/modules/client-support/pages/ClientSupportPage/providers/InstagramAccountProvider/useInstagramAccount";
import { useManageAccountsDrawer } from "@web-src/modules/client-support/pages/ClientSupportPage/components/ManageAccountsDrawer/providers/ManageAccountsDrawerContext";
import { ReactComponent as InstagramIcon } from "./assets/instagram.svg";
import { ChannelTile } from "../ChannelTile";

export const InstagramTile: React.FC<{
  isSelected: boolean;
  onSelect: () => void;
}> = (props) => {
  const { t } = useTranslations();
  const {
    instagramAccount,
    isConnected,
    loginInstagramAccount,
    isConnectingInstagramAccount,
  } = useInstagramAccount();
  const { openManageAccountDrawer } = useManageAccountsDrawer();

  return (
    <ChannelTile
      title={t({
        id: "common.instagram",
        defaultMessage: "Instagram",
      })}
      isConnected={isConnected}
      isDisabled={isConnectingInstagramAccount}
      onClick={() =>
        isConnected
          ? openManageAccountDrawer({ name: "instagramAccount" })
          : loginInstagramAccount()
      }
      description={
        isConnected
          ? t(
              {
                id: "cx-ai-agents-page.instagram-name",
                defaultMessage: "Name: {name}",
              },
              { name: instagramAccount?.name || "-" }
            )
          : t({
              id: "cx-ai-agents-page.instagram-connect-description",
              defaultMessage: "Elevate your marketing with Instagram",
            })
      }
      icon={<InstagramIcon />}
      status={
        isConnected
          ? {
              type: "connected",
              text: t({
                id: "common.connected",
                defaultMessage: "Connected",
              }),
            }
          : undefined
      }
      {...props}
    />
  );
};
